module.exports = __webpack_public_path__ + "img/ha-active.3c8632ee.png";